import Vue from 'vue';
import Vuex from 'vuex';

import storeFunctions from '../../../../world/spa/libs/vuexFunctions';

/* Modules */
import config from './modules/config';
import licenses from './modules/licenses';
import works from './modules/works';
import users from './modules/users';
import invites from './modules/invites';
import resources from './modules/resources';
import contacts from './modules/contacts';
import contactPlaces from './modules/contactPlaces';
import projects from './modules/projects';
import projectCategories from './modules/projectCategories';
import employments from './modules/employments';
import tasks from './modules/tasks';
import events from './modules/events';
import places from './modules/places';
import dailyCounters from './modules/dailyCounters';

import workPlaceAssocs from './modules/workPlaceAssocs';

Vue.use(Vuex);

export default new Vuex.Store({
  // Default
  state: {
    ...storeFunctions.rootState
  },
  getters: {
    ...storeFunctions.rootGetters
  },
  mutations: {
    ...storeFunctions.rootMutations
  },
  actions: {
    ...storeFunctions.rootActions
  },
  // Modules
  modules: {
    config,
    licenses,
    works,
    users,
    resources,
    invites,
    contacts,
    contactPlaces,
    projects,
    projectCategories,
    employments,
    tasks,
    events,
    places,
    workPlaceAssocs,
    dailyCounters,
  },
});
